import 'css-chunksrc/client/scenes/assignToTask/projectSelection/zones/zone/projects/styles.scss';export default {
  "projects": "_projects_7lty2_1"
};